import React, { useMemo, useReducer } from 'react';

import { useRetailKADUpsellMessage } from '../../hooks/useRetailKADUpsellMessage';
import { useUpsellSelection } from '../../hooks/useUpsellSelection';
import { UpsellContext, initialState, reducer } from '../../state';
import { RetailKADUpsell } from '../retail-kad-upsell/RetailKADUpsell';
import { TargetedUpsell } from '../targeted-upsell';
import { OpenMarketOptions, UpsellFeedback } from '../upsell-feedback/UpsellFeedback';

type NewronUpsellProps = {
  cells: string[];
  openMarketOptions: OpenMarketOptions[];
};

export const NewronUpsell = ({ cells, openMarketOptions }: NewronUpsellProps): JSX.Element => {
  const { retailKADMessage } = useRetailKADUpsellMessage(cells);

  const { shouldShowRDDUpsell, shouldShowRetailKADUpsell } = useUpsellSelection(cells, !!retailKADMessage);
  const [state, dispatch] = useReducer(reducer, initialState);
  const contextValue = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <>
      <UpsellContext.Provider value={contextValue}>
        <UpsellFeedback cells={cells} openMarketsOptions={openMarketOptions} />
        {shouldShowRetailKADUpsell && <RetailKADUpsell retailKADMessage={retailKADMessage} />}
        {shouldShowRDDUpsell && <TargetedUpsell cells={cells} openMarketsOptions={openMarketOptions} />}
      </UpsellContext.Provider>
    </>
  );
};
